import { routePaths } from './data';

const bladeRoutes = [
  '/kyc',
  '/kyc/bank-details',
  '/kyc/bank-details/manual',
  '/kyc/user-selection',
  '/kyc/documents-upload',
  '/kyc/company-details-verification',
  '/kyc/company-details-verification/gstin',
  '/kyc/company-details-verification/update-address',
  '/kyc/company-details-verification/cin-or-llpin',
  '/kyc/company-details-verification/manual',
  '/kyc/company-details-verification/add-address',
  '/kyc/company-details-verification/pan',
  '/onboarding',
  '/onboarding/details',
  '/onboarding/details/basic-details',
  '/onboarding/details/pan-prefill',
  '/workflow',
  '/workflow/edit-payroll',
  '/workflow/finalize-payroll',
  '/workflow/salary-revision',
  '/my-requests',
  '/my-requests/edit-payroll',
  '/my-requests/edit-payroll/pending-approvals',
  '/my-requests/edit-payroll/initiated-by-me',
  '/my-requests/edit-payroll/completed',
  '/my-requests/finalize-payroll',
  '/my-requests/finalize-payroll/pending-approvals',
  '/my-requests/finalize-payroll/initiated-by-me',
  '/my-requests/finalize-payroll/completed',
  '/my-requests/salary-revision',
  '/my-requests/salary-revision/pending-approvals',
  '/my-requests/salary-revision/initiated-by-me',
  '/my-requests/salary-revision/completed',
  routePaths.employeeLoans.root,
  routePaths.employeeLoans.settings,
  routePaths.flexibleBenefits.root,
  routePaths.flexibleBenefits.listView,
  routePaths.flexibleBenefits.create,
  routePaths.flexibleBenefits.declaration,
  routePaths.flexibleBenefits.settings,
  routePaths.flexibleBenefits.settingsGeneral,
  routePaths.flexibleBenefits.settingsDeclaration,
  routePaths.flexibleBenefits.settingsProofUpload,
  routePaths.flexibleBenefits.settingsWindowAdavanced,
  routePaths.flexibleBenefits.claims.listView,
  routePaths.flexibleBenefits.claims.create,
  routePaths.flexibleBenefits.claims.edit,
  '/nps',
  '/nps/settings',
  '/nps/declaration',
  '/bonus/view',
  '/bonus/create',
  routePaths.settings.employeeData.root,
  routePaths.settings.employeeData.general,
  routePaths.settings.employeeData.fields,
  routePaths.settings.darwinbox.root,
  routePaths.settings.darwinbox.introduction,
  routePaths.settings.darwinbox.manage,
  routePaths.settings.darwinbox.integration,
  routePaths.settings.darwinbox.settings.root,
  routePaths.settings.darwinbox.settings.entitySelection,
  routePaths.settings.darwinbox.settings.fields,
  routePaths.settings.darwinbox.settings.employeeContractorMapping,
  routePaths.settings.darwinbox.settings.syncConfirmation,
  routePaths.settings.darwinbox.settings.syncInProgress,
  routePaths.settings.darwinbox.settings.disableIntegration,
  routePaths.settings.hibob.root,
  routePaths.settings.hibob.introduction,
  routePaths.settings.hibob.manage,
  routePaths.settings.hibob.integration,
  routePaths.settings.hibob.settings.root,
  routePaths.settings.hibob.settings.entitySelection,
  routePaths.settings.hibob.settings.fields,
  routePaths.settings.hibob.settings.employeeContractorMapping,
  routePaths.settings.hibob.settings.syncConfirmation,
  routePaths.settings.hibob.settings.syncInProgress,
  routePaths.settings.hibob.settings.disableIntegration,
  routePaths.settings.worq.root,
  routePaths.settings.worq.introduction,
  routePaths.settings.worq.manage,
  routePaths.settings.worq.integration,
  routePaths.settings.worq.settings.root,
  routePaths.settings.worq.settings.entitySelection,
  routePaths.settings.worq.settings.fields,
  routePaths.settings.worq.settings.employeeContractorMapping,
  routePaths.settings.worq.settings.syncConfirmation,
  routePaths.settings.worq.settings.syncInProgress,
  routePaths.settings.worq.settings.disableIntegration,
  routePaths.settings.workline.root,
  routePaths.settings.workline.introduction,
  routePaths.settings.workline.manage,
  routePaths.settings.workline.integration,
  routePaths.settings.workline.settings.root,
  routePaths.settings.workline.settings.entitySelection,
  routePaths.settings.workline.settings.fields,
  routePaths.settings.workline.settings.employeeContractorMapping,
  routePaths.settings.workline.settings.syncConfirmation,
  routePaths.settings.workline.settings.syncInProgress,
  routePaths.settings.workline.settings.disableIntegration,
  routePaths.fnf.root,
  routePaths.fnf.initiate,
  routePaths.fnf.releaseNetPay,
  routePaths.taxDeclarationAndProofSettings.root,
  routePaths.taxDeclarationAndProofSettings.settings,
  routePaths.taxDeclarationAndProofSettings.settingsGeneral,
  routePaths.taxDeclarationAndProofSettings.settingsDeclaration,
  routePaths.taxDeclarationAndProofSettings.settingsProofUpload,
  routePaths.taxDeclarationAndProofSettings.settingsCustomWindow,
  routePaths.customReport.root,
  '/404',
  routePaths.settings.rxIntegration.root,
  routePaths.settings.rxIntegration.preCheck,
  routePaths.settings.rxIntegration.activate,
  routePaths.payrollAiAssistant,
  routePaths.integrations.v2,
  routePaths.payrollSetupSettings.root,
  routePaths.salaryExplainer,
  routePaths.orgSettings.apiAccess,
  routePaths.salaryComponents.root,
  routePaths.salaryComponents.earningsListView,
  routePaths.salaryComponents.deductionsListView,
  routePaths.salaryComponents.nonPayableBenefitsListView,
  routePaths.salaryComponents.perquisitesListView,
  routePaths.salaryComponents.create.earnings.root,
  routePaths.salaryComponents.create.earnings.generalDetails,
  routePaths.salaryComponents.create.earnings.taxationDetails,
  routePaths.salaryComponents.create.earnings.review,
  routePaths.salaryComponents.create.deductions.root,
  routePaths.salaryComponents.create.deductions.generalDetails,
  routePaths.salaryComponents.create.deductions.payAndTaxDetails,
  routePaths.salaryComponents.create.deductions.review,
  routePaths.salaryComponents.create.nonPayableBenefits.root,
  routePaths.salaryComponents.create.nonPayableBenefits.generalDetails,
  routePaths.salaryComponents.create.nonPayableBenefits.review,
  routePaths.salaryComponents.create.perquisites.root,
  routePaths.salaryComponents.create.perquisites.generalDetails,
  routePaths.salaryComponents.create.perquisites.review,
  routePaths.salaryComponents.edit.perquisites.root,
  routePaths.salaryComponents.edit.earnings.root,
  routePaths.salaryComponents.edit.earnings.generalDetails,
  routePaths.salaryComponents.edit.earnings.taxationDetails,
  routePaths.salaryComponents.edit.earnings.review,
  routePaths.salaryComponents.edit.deductions.root,
  routePaths.salaryComponents.edit.deductions.generalDetails,
  routePaths.salaryComponents.edit.deductions.payAndTaxDetails,
  routePaths.salaryComponents.edit.deductions.review,
  routePaths.salaryComponents.edit.nonPayableBenefits.root,
  routePaths.salaryComponents.edit.nonPayableBenefits.generalDetails,
  routePaths.salaryComponents.edit.predefinedComponent,
  routePaths.salaryComponents.create.nonPayableBenefits.root,
  routePaths.salaryComponents.create.nonPayableBenefits.generalDetails,
  routePaths.salaryComponents.create.nonPayableBenefits.review,
  routePaths.attendance.root,
  routePaths.salaryStructure.root,
  routePaths.payDetails.root,
  routePaths.payDetails.compensation.root,
  routePaths.payDetails.compensation.ctc,
  routePaths.payDetails.compensation.deductions,
  routePaths.payDetails.compensation.perquisites,
  routePaths.payDetails.compensation.flexi,
  routePaths.payDetails.compensation.edit.root,
  routePaths.payDetails.compensation.edit.salaryDetails,
  routePaths.payDetails.compensation.edit.updateStructure,
  routePaths.payDetails.compensation.edit.review,
  routePaths.payDetails.compensation.myCompensation.root,
  routePaths.payDetails.compensation.myCompensation.ctc,
  routePaths.payDetails.compensation.myCompensation.deductions,
  routePaths.payDetails.compensation.myCompensation.perquisites,
  routePaths.payDetails.compensation.myCompensation.flexi,
  // routePaths.reimbursements.pending,// DONT UNCOMMENT THIS LINE
  // routePaths.reimbursements.pending.approval, // DONT UNCOMMENT THIS LINE
  // routePaths.reimbursements.pending.payment, // DONT UNCOMMENT THIS LINE
  routePaths.employeeDetailsV2.root,
  routePaths.employeeDetailsV2.bankAccountDetails.root,
  routePaths.employeeDetailsV2.bankAccountDetails.preview,
  routePaths.employeeDetailsV2.bankAccountDetails.add,
  routePaths.employeeDetailsV2.bankAccountDetails.edit,
  routePaths.approvalWorkflows.myRequests.employeeBankAccount.root,
  routePaths.approvalWorkflows.myRequests.employeeBankAccount.pendingApprovals,
  routePaths.approvalWorkflows.myRequests.employeeBankAccount.completed,
  routePaths.approvalWorkflows.myRequests.flexiReimbursement.root,
  routePaths.approvalWorkflows.myRequests.flexiReimbursement.pendingApprovals,
  routePaths.approvalWorkflows.myRequests.flexiReimbursement.completed,
  routePaths.employeeOnboarding.employeeSelfOnboarding.root,
  routePaths.employeeOnboarding.employeeSelfOnboarding.previewInformation,
  routePaths.employeeOnboarding.employeeSelfOnboarding.kycDetails,
  routePaths.employeeOnboarding.employeeSelfOnboarding.bankDetails,
  routePaths.employeeOnboarding.employeeSelfOnboarding.statutoryDetails,
  routePaths.employeeOnboarding.employeeSelfOnboarding.personalDetails,
  routePaths.employeeOnboarding.employeeSelfOnboarding.reviewDetails,
  routePaths.employeeOnboarding.contractor,
  routePaths.bulkUploads.root,
  routePaths.bulkUploads.initiate,
  routePaths.bulkUploads.preview,
  routePaths.reports.missingInformation.root,
  routePaths.reports.missingInformation.bankAccount,
  routePaths.reports.missingInformation.statutory,
  routePaths.reports.missingInformation.personal,
  routePaths.employeeDetailsV2.statutoryContributions.edit,
  routePaths.peopleV2,
  routePaths.employeeOnboarding.contractorSelfOnboarding.root,
  routePaths.employeeOnboarding.contractorSelfOnboarding.kycDetails,
  routePaths.employeeOnboarding.contractorSelfOnboarding.bankDetails,
  routePaths.employeeOnboarding.contractorSelfOnboarding.personalDetails,
  routePaths.employeeOnboarding.contractorSelfOnboarding.reviewDetails,
  routePaths.employeeOnboarding.employee.root,
  routePaths.employeeOnboarding.employee.basicDetails,
  routePaths.employeeOnboarding.employee.compensationBreakdown,
  routePaths.employeeOnboarding.employee.compensation,
  routePaths.employeeOnboarding.employee.compliance,
  routePaths.employeeOnboarding.employee.review,
  routePaths.officeLocation.root,
  routePaths.officeLocation.create,
  routePaths.officeLocation.preview,
  routePaths.reports.updateSalaryRegister.root,
  routePaths.reports.updateSalaryRegister.confirmation,
  routePaths.aiWorkflow.root,
  routePaths.aiWorkflow.myFlows,
  routePaths.aiWorkflow.activity,
  routePaths.aiWorkflow.create,
  routePaths.aiWorkflow.edit,
  routePaths.orgSettings.timeAndAttendance.root,
  routePaths.orgSettings.timeAndAttendance.attendance,
  routePaths.orgSettings.timeAndAttendance.leaves,
  routePaths.orgSettings.timeAndAttendance.payRules,
  routePaths.loansV2.root,
  routePaths.loanPaymentV2.root,
  routePaths.salaryComponents.edit.overtime,
];
// make an entry in includes/utils/BladeRoutes.php too please.

export default bladeRoutes;
